export default __webpack_public_path__ + "static/media/buy.d92dfd20.svg";